module.exports = __webpack_public_path__ + "img/ic_scale.057db96b.svg";